import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ExploreView from "../views/categorylist.vue";
import ListingView from "../views/eventlist.vue";
import DetailView from "../views/singleeventlist.vue";
import LoginView from "../views/login.vue";
import PostView from "../views/form.vue";
import ProfileView from "../views/profile.vue";
import MarketView from "../views/listing.vue";
import DirectoryView from "../views/DirectoryView.vue";
import SearchResults from "../views/SearchResults.vue";
import OffersView from "../views/OffersView.vue";
import CompleteProfile from "../views/CompleteProfile.vue";

const routes = [
  { path: "/", name: "home", component: HomeView },
  { path: "/explore", alias: "/categorylist", name: "explore", component: ExploreView },
  { path: "/list", name: "listings", component: ListingView },
  { path: "/details", alias: ["/singleeventlist", "/singlebusinesslist"], name: "details", component: DetailView },
  { path: "/post", alias: "/form", name: "post", component: PostView },
  { path: "/market", alias: "/listing", name: "market", component: MarketView },
  { path: "/offers", name: "offers", component: OffersView },
  { path: "/profile", name: "profile", component: ProfileView },
  { path: "/login", alias: "/register", name: "login", component: LoginView },
  { path: "/complete-profile", name: "complete-profile", component: CompleteProfile },
  { path: "/emergencylist", component: DirectoryView, props: { kind: "emergency" } },
  { path: "/dailyneed", component: DirectoryView, props: { kind: "daily" } },
  { path: "/searchbar", component: SearchResults },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});
